import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { deleteIdData } from "../../../lib/studentlessons";
import { getStudentIdData } from "../../../lib/studentnotes";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
export default function StudentNotes() {
  const [notes, setNotes] = useState([]);
  const [classforLesson, setClassForLesson] = useState(9);
  const { profile } = useAuth();

  const slug = profile.id;
  const cls = profile.class;
  const role = profile.role;

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      //getDataWithTypeFromParamter();
      console.log("Delete", id);
      //router.refresh();
    }
  };

  async function getData() {
    const note = await getStudentIdData(slug);
    //console.log("lesson",lesson.filter(cat => cat.class == catg));
    setNotes(note);
    console.log("note", note);
  }

  useEffect(() => {
    getData(classforLesson);
  }, []);
  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";

  const essentialheader = (
      name,
      student911buttonname,
      student911buttonlink,
      student12buttonname,
      student12buttonlink,
    ) => {
      return (
        <div className="d-flex p-2 justify-content-between align-items-center">
          <div className="p-2">
            <h3>{name}</h3>
          </div>
          <div className="d-flex">
            <div className="ticket-btn-grp">
              {role === "Student911" ? (
                <Link to={student911buttonlink}>{student911buttonname}</Link>
                ) : (
                <Link to={student12buttonlink}>{student12buttonname}</Link>
                )}
            </div>
          </div>
        </div>
      );
    };
  
  return (
    <>
      {isStudent && <STopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
      {isStudent911 && <S911TopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
      {isStudent12 && <S12TopMenu slug={slug} activeMenu="PersonelQuestionsList" />}

      <div className="col-12">
        <div className="settings-widget profile-details">
          <div className="settings-inner-blk p-0">
            {essentialheader(
              "Notes",
              "Add New Note",
              "/student911/student-notes-edit/Add/0",
              "Add New Note",
              "/student12/student-notes-edit/Add/0"
            )}
            <div className="comman-space pb-0">
              <div className="settings-invoice-blk table-responsive">
                {/* Invoice info */}
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Regarding</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notes.map(function (data) {
                      return (
                        <tr key={data.id}>
                          <td>
                            <Link to="#" className="invoice-no">
                              {data.id}
                            </Link>
                          </td>
                          <td>{data.title}</td>
                          <td>
                            <div className="profile-share d-flex align-items-center justify-content-end">
                              <Link
                                to={`/student/student-notes-edit/Update/${data.id}`}
                                className="btn btn-success btn-sm"
                              >
                                Update
                              </Link>
                              {/*}
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                            */}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {/* Invoice info */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
